export default __webpack_public_path__ + "static/media/Remote.96e7af14.png";